<template>
  <div class="select">
    <input readonly type="text" :value="timeFromat" :placeholder="placeholder" class="input" @click="visible = true" />
    <Popup v-model="visible" position="bottom">
      <DatetimePicker
        v-model="date"
        type="datetime"
        @cancel="visible = false"
        show-toolbar
        @confirm="onConfirm"
        :formatter="formatter"
        :min-date="minDate"
      />
      <!-- :min-date="minDate" -->
    </Popup>
  </div>
</template>

<script>
import moment from 'moment';
import { DatetimePicker, Popup } from 'vant';
export default {
  props: ['value', 'placeholder'],
  components: { DatetimePicker, Popup },
  data() {
    return {
      visible: false,
      minDate: new Date(moment().format('YYYY-MM-DD')),
      date: this.value,
    };
  },
  computed: {
    timeFromat() {
      return this.value && moment(this.value).format('YYYY-MM-DD HH:mm');
    },
  },
  methods: {
    onConfirm(value) {
      this.$emit('update:value', value);
      this.visible = false;
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.input {
  border: none;
  font-size: 30px;
  padding: 6px 0;
  line-height: 34px;
  color: #3d424d;
  width: 100%;

  &::placeholder {
    color: #949aa4;
  }
}
</style>
